export default __webpack_public_path__ + "media/mock/src/img/logo_master-5aa9a2eb424c19bad217c509e81d0dfe.png";